import { useMaptilerStyleJson } from "@nens/react-map-gl/utils";

import { useStatusQuery } from "@/queries/query-status";

const SATALITE_MAP_STYLE_UUID = "979c501d-dd64-478a-a7bf-960515d5c0d2";

export const useMapStyle = () => {
  const statusResponse = useStatusQuery();
  const maptilerApiKey =
    statusResponse.isSuccess && statusResponse.data.authenticated
      ? statusResponse.data.maptilerApiKey
      : null;
  const mapStyle = useMaptilerStyleJson(SATALITE_MAP_STYLE_UUID, maptilerApiKey, false);

  return mapStyle;
};
